import { Dispatch, SetStateAction, useContext } from "react";
import { StateContextType } from "../../../types/state.types";
import MainStateContext from "../../../state/mainStateContext";
import OrderConfirmationPhotoUpload from "./OrderConfirmationPhotoUpload";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFaceSmile } from "@fortawesome/free-regular-svg-icons";
import OrderConfirmationBoothQRCode from "./OrderConfirmationBoothQRCode";
import { Say } from "../../../languages";

type Props = {
  visible?: boolean;
  currentOrder: {
    firstName: string;
    lastName: string;
    orderId: string;
  };
  toggleBoothComplete: Dispatch<SetStateAction<boolean>>;
};

const OrderConfirmationStart = ({ visible = true, currentOrder, toggleBoothComplete }: Props) => {
  const { state } = useContext(MainStateContext) as StateContextType;
  const { eventData } = state;
  const photoType = eventData?.PhotoType?.toLowerCase() || "all";
  const { firstName } = currentOrder;

  if (!visible) {
    return null;
  }

  return (
    <div className="order-confirmation__booth">
      <div className="order-confirmation__booth-header">
        <p className="margin-zero eta order-confirmation__accepted">
          <Say phrase="chosen.thank_you.payment_accepted" />{" "}
          <Say
            phrase="chosen.thank_you.needs_photo"
            mutator={(value) => value.replace("{{firstName}}", firstName)}
          />
          <span>
            <FontAwesomeIcon icon={faFaceSmile} />
          </span>
        </p>
      </div>
      <OrderConfirmationBoothQRCode
        visible={["all", "booth"].includes(photoType)}
        toggleBoothComplete={toggleBoothComplete}
        currentOrder={currentOrder}
      />
      <OrderConfirmationPhotoUpload currentOrder={currentOrder} />
    </div>
  );
};

export default OrderConfirmationStart;
